import styles from '../../../pages/Badging/AdminPrint/AdminPrint.module.css'

const NewRegistration = ({ formData, handleChange, handleTrigger, regError }) => {

    return (
        <div className={styles.dropdownContainer}>
            <input
                className={styles.inputContainer}
                type="text"
                value={formData.newRegistration ? formData.newRegistration : ''}
                onChange={handleChange} 
                name="newRegistration"
            />
            <button onClick={handleTrigger} className={styles.printButton} style={{ marginLeft: '20px' } }>
               Trigger Reload
            </button>
            {regError && regError.length > 0 ?
                <div style={{color:'red'} }>
                    <br />
                    Error: {regError }
                </div>

                : <></>
            }


        </div>
    );
}

export default NewRegistration;